import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      "& h2": {
        marginTop: 0,
      },
      "& p": {
        wordBreak: "break-all",
      },
    },
    row: {
      display: "flex",
      flexDirection: "column",
      marginTop: "10px",
      textAlign: "left",
      [theme.breakpoints.up("mobile")]: {
        flexDirection: "row",
        justifyContent: "space-between",
      },
    },
    link: {
      minWidth: 100,
      textAlign: "left",
      textDecoration: "underline",
      [theme.breakpoints.up("mobile")]: {
        textAlign: "right",
      },
    },
    placeholder: {
      display: "inline-block",
      width: "120px",
    },
  }),
  { name: "LoginDetails" },
);
